import adminRoutes from "./Admin";

const adminRoutesMap = {
  ...adminRoutes,
};

export default adminRoutesMap;
